const Tag = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.75 2C20.9926 2 22 3.00736 22 4.25V9.71196C22 10.5738 21.6577 11.4003 21.0484 12.0098L12.5473 20.5129C11.2779 21.7798 9.22214 21.7807 7.95098 20.5143L3.48927 16.0592C2.21881 14.7913 2.21718 12.7334 3.4855 11.4632L11.9852 2.95334C12.5948 2.34297 13.422 2 14.2847 2H19.75ZM19.75 3.5H14.2847C13.8202 3.5 13.3747 3.68467 13.0465 4.01333L4.5343 12.5358C3.86408 13.2207 3.86917 14.3191 4.54902 14.9977L9.01024 19.4522C9.69511 20.1345 10.8035 20.134 11.4872 19.4518L19.9876 10.9492C20.3157 10.6211 20.5 10.176 20.5 9.71196V4.25C20.5 3.83579 20.1642 3.5 19.75 3.5ZM17 5.50218C17.8284 5.50218 18.4999 6.17374 18.4999 7.00216C18.4999 7.83057 17.8284 8.50213 17 8.50213C16.1716 8.50213 15.5 7.83057 15.5 7.00216C15.5 6.17374 16.1716 5.50218 17 5.50218Z"
        fill="url(#paint0_linear_338_4412)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_338_4412"
          x1="2.58704"
          y1="2"
          x2="41.7469"
          y2="11.2067"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A256BC" />
          <stop offset="1" stopColor="#298ee6" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default Tag;
